import { PreFilledTextFormElement as PreFilledTextFormElementType } from '@gearbelt/global';

import { RichText } from '@/components/ui/rich-text';

import { ConfigLabel } from '../config-label';
import Description from '../description';

export function PreFilledTextFormElement({ element }: { element: PreFilledTextFormElementType }) {
  return element.description && <Description content={element.description} className="text-default-text text-base" />;
}

export function PreFilledTextFormElementMock({ element }: { element: PreFilledTextFormElementType }) {
  return <div>{element.description && <Description content={element.description} className="text-default-text text-base" />}</div>;
}

export function PreFilledTextFormElementConfig({
  element,
  onChange,
}: {
  element: PreFilledTextFormElementType;
  onChange?: (updates: Partial<PreFilledTextFormElementType>) => void;
}) {
  return (
    <ConfigLabel noLabel>
      <RichText
        value={element.description}
        placeholder="Type text ..."
        onChange={(value) => {
          onChange?.({ description: value.toString() });
        }}
      />
    </ConfigLabel>
  );
}
